import factory from '@helpers/storeFactories/factory';
import { apiService } from '@api';
import normalizeProviders from '@/data/response/normalizeProviders';

const STORE_NAME = 'providers';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiService.product.providers.get,
    },
    {
        normalizeItemFn: normalizeProviders,
    }
);

export default store;
